import PCPFinance from './pcp';
import HPFinance from './hp';

/**
 * Helper method to return an object representing the keys we want to show on the used more details page. We can order the keys here, change the short and long name, set the fallback mileage/deposit/terms if the CW request fails to get that key, and determine if the finance option should show if the key is not available for the vehicle
 * @param {object} vehicle
 */
export default function(vehicle) {
    // console.log(vehicle);
    if (vehicle.carOrLCV == 'Lcv' || vehicle.businessOnly === true) {
        return [
            new HPFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'vauxhall') {
        return [
            new PCPFinance(vehicle),
            new HPFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'peugeot') {
        return [
            new PCPFinance(vehicle),
            new HPFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'ds') {
        return [
            new PCPFinance(vehicle),
            new HPFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'citroen') {
        return [
            new PCPFinance(vehicle),
            new HPFinance(vehicle),
        ];
    }

    return [
        new PCPFinance(vehicle),
        new HPFinance(vehicle),
    ];
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/get-finance-types.js